import { getPrivacyPolicyData } from "../../../app/api/getPrivacyPolicyData";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import {
  IApiResponse,
  IPrivacyPolicyResponse,
} from "../../../Orchestrator/Types/Index";

class GetCmsPrivacyPolicyActon extends BaseAction<
  IPrivacyPolicyResponse,
  void
> {
  override async run(): Promise<IPrivacyPolicyResponse | null> {
    let privacyPolicyContent: IPrivacyPolicyResponse | null = null;
    try {
      const response: IApiResponse<IPrivacyPolicyResponse> =
        await getPrivacyPolicyData();
      if (response.status === "ok" && response.answer) {
        const content = response.answer;
        if (content) {
          privacyPolicyContent = content;
          updateRecoilState(
            "privacyPolicyContentResponseAtom",
            privacyPolicyContent?.data?.privacy_policy
          );
        } else {
          console.warn("No content available.");
        }
      } else {
        console.warn("Failed to fetch content.");
      }
    } catch (error: any) {
      console.error("Error fetching content:", error);
    } finally {
      return privacyPolicyContent;
    }
  }
}

export const getCmsPrivacyPolicyActon = new GetCmsPrivacyPolicyActon();
